import moment from "moment";
import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { updateProfile } from "../../redux/action";
import { PROFILE } from "../../redux/constant";

import {
  CustomButton,
  CustomInput,
  DefaultLoader,
  StepLabel,
} from "../../../components";

import { allowedIdType } from "../../../utils/allowedIdType";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";
import styles from "../styles";

const UpdateVC = props => {
  const { loading, profile, updateProfile, history } = props;

  const [isOptInForNotification, setOptInForNotification] = useState(() => {
    if (profile?.optIn) return "Yes";

    return "No";
  });

  const localIdentity = profile?.identities?.find(allowedIdType);

  const handleUpdate = () => {
    if (
      (!profile?.optIn && isOptInForNotification === "No") ||
      (profile?.optIn && isOptInForNotification === "yes")
    )
      return;

    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: profile?.investmentObjCd,
      employerName: profile?.employerName,
      optIn: isOptInForNotification === "Yes",
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        line2: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line2,
        line3: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line3,
        postCode: profile?.contacts.find(contact => contact.postCode).postCode, //R
        city: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city,
        state: profile?.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship,
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    updateProfile({ payloadData: payload, from: PROFILE });
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {loading && <DefaultLoader />}
      <StepLabel
        title="Opt in notification"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <CustomInput
          label="Opt in for EInvoice notification"
          name="isOptInForNotification"
          value={isOptInForNotification}
          onChange={e => setOptInForNotification(e.target.value)}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
        <div style={styles.btnContainer}>
          <CustomButton
            text="Save"
            variant="contained"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={handleUpdate}
          />
        </div>
      </form>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
  }),
  {
    updateProfile,
  }
);

export default compose(
  withRouter,
  withConnect
)(UpdateVC);
